import { CREW_ROLE_SUPERVISING_INSTRUCTOR } from '../common/flight/CrewRoleTypes';
import { FlightOps } from '../common/flight/FlightOpsTypes';
import { LogbookDutyMode } from '../common/flight/LogbookCustomData';
export var FinishedFlightLegLikeSource;
(function (FinishedFlightLegLikeSource) {
    FinishedFlightLegLikeSource["leg"] = "leg";
    FinishedFlightLegLikeSource["logbook"] = "logbook";
    FinishedFlightLegLikeSource["quotation"] = "quotation";
    FinishedFlightLegLikeSource["sandbox"] = "sandbox";
    FinishedFlightLegLikeSource["scheduling"] = "scheduling";
})(FinishedFlightLegLikeSource || (FinishedFlightLegLikeSource = {}));
export function isFlightLegLikeFromLeg(leg) {
    return leg.source === FinishedFlightLegLikeSource.leg;
}
export function flightLegLikeHasLegId(leg) {
    return (leg.source === FinishedFlightLegLikeSource.leg ||
        leg.source === FinishedFlightLegLikeSource.scheduling ||
        leg.source === FinishedFlightLegLikeSource.sandbox);
}
export function isFlightLegLikeFromLogbookRecord(leg) {
    return leg.source === FinishedFlightLegLikeSource.logbook;
}
export function isSupervisingInstructorOnLegLike(leg, crewId) {
    return isFlightLegLikeFromLeg(leg) && isSupervisingInstructorOnLeg(leg, crewId);
}
export function legToLegLike(leg) {
    return Object.assign(Object.assign({}, leg), { source: FinishedFlightLegLikeSource.leg, legId: leg.id });
}
export function isSupervisingInstructorOnLeg(leg, crewId) {
    var _a;
    return leg.sicId === crewId && ((_a = leg.sicRoles) === null || _a === void 0 ? void 0 : _a.includes(CREW_ROLE_SUPERVISING_INSTRUCTOR));
}
export function logbookRecordToLegLike(logbookRecord) {
    var _a;
    if (!(logbookRecord.departureTime && logbookRecord.arrivalTime)) {
        throw new Error('Cannot create Flight Leg like from logbook without departure and arrival times');
    }
    const ops = ((_a = logbookRecord.customData) === null || _a === void 0 ? void 0 : _a.duty) === LogbookDutyMode.commercial ? FlightOps.CAT : FlightOps.NCO;
    return {
        timeOut: new Date(logbookRecord.departureTime),
        timeIn: new Date(logbookRecord.arrivalTime),
        ops,
        airportOffIcao: logbookRecord.departurePlace || '',
        airportOnIcao: logbookRecord.arrivalPlace || '',
        source: FinishedFlightLegLikeSource.logbook,
        logbookRecordId: logbookRecord.id,
        id: logbookRecord.id,
    };
}
//# sourceMappingURL=FinishedFlightLegLike.js.map